import React, { useEffect, useState } from "react";
import ko from "knockout";
import Context from "../../context/Message";
import MessagesContainer from "./MessagesContainer";

export default ({
    $app,
    name,
    koPosition,
    uiTab,
    koEnabled,
    moduleSettings,
    allowAnswer,
    sortMessages,
    sortChildren,
    fetchMessages,
    createMessage,
    likeMessage,
    messageFetchLimit = 100,
}) => {
    const $locale = $app.require('locale');
    const $auth = $app.require('auth');
    const $player = $app.require('player');
    const $comet = $app.require('comet');
    const $playerNotification = $app.require('playerNotification');

    const [enabled, setEnabled] = useState(koEnabled());
    const [position, setPosition] = useState(koPosition());
    const [client, setClient] = useState($auth.client()?.getCleanData());
    const [filterMessages, setFilterMessages] = useState($app.event().isEpisodeRecorded() ? 'episode' : 'stream');
    const [currentStream, setCurrentStream] = useState($app.currentStream()?.getCleanData());
    const [episode, setEpisode] = useState($app.episode()?.getCleanData());
    const [messageTargets, setMessageTargets] = useState([]);
    const commentRooms = $app.event().stream().map(stream => ({ ...stream.commentRoom.getCleanData(), streamKey: stream.streamKey() }));
    const questionRooms = $app.event().stream().map(stream => ({ ...stream.questionRoom.getCleanData(), streamKey: stream.streamKey() }));
    const currentRoom = !!currentStream &&
        [...commentRooms, ...questionRooms].filter(({ roomType }) => roomType === name).find((room) => room.streamKey === currentStream.streamKey);

    useEffect(() => {
        ko.computed(() => {
            setEnabled(koEnabled());
        });
        ko.computed(() => {
            setPosition(koPosition());
        });
        ko.computed(() => {
            setClient($auth.isLoggedIn() ? $auth.client()?.getCleanData() : null);
        });
        ko.computed(() => {
            setCurrentStream($app.currentStream()?.getCleanData());
        });
        ko.computed(() => {
            setEpisode($app.episode()?.getCleanData());
        });
        ko.computed(() => {
            let targets = [];
            if (moduleSettings.allowTargetMessage() && $app.currentEpisode()) {
                targets = $app.currentEpisode().speakers().map(({ id, fullname }) => ({
                    title: fullname,
                    value: id,
                }));
            }
            setMessageTargets(targets);
        });
    }, []);

    const onClickMessageTime = (message) => {
        if (!message.playerTime || !message.roomId) {
            return;
        }

        const stream = $app.event().stream().find(s => [s.commentRoom.id(), s.questionRoom.id()].includes(message.roomId));

        if (!stream) {
            return console.log('Stream not found', message.streamId);
        }
        $player
            .setStream(stream)
            .then(() => $player.setCurrentTime(message.playerTime))
            ;
    }

    const filters = ['event'];
    if ($app.event().stream().length > 1 && filterMessages !== 'episode') {
        filters.push('stream');
    }

    const context = {
        $locale,
        $playerNotification,
        name,
        client,
        allowAnswer,
        allowAnonymousMessage: moduleSettings.allowAnonymousMessage(),
        maxMessageLength: moduleSettings.maxMessageLength(),
        filters,
        messageTargets,
        setFilterMessages,
        sortMessages,
        sortChildren,
        logout: $auth.logout,
        onClickMessageTime,
        fetchMessages,
        createMessage,
        likeMessage: moduleSettings.like() ? likeMessage : null,
        showClientLogin: $auth.show,
        toggleClientSettings: $auth.toggleSettings,
        clientNicknameFormat: $app.event().moduleAuth.nicknameFormat(),
    }

    if (!enabled) {
        return null;
    }

    return (
        <Context.Provider value={context}>
            <MessagesContainer
                comet={$comet}
                uiTab={uiTab}
                position={position}
                messageLimit={messageFetchLimit}
                episode={episode}
                currentStream={currentStream}
                currentRoom={currentRoom}
            />
        </Context.Provider>
    );
};
